import { datadogRum } from '@datadog/browser-rum';
import { Environment } from '@ph-env/model/environment.model';
import { Env } from '@ph-core/enums/environment';

const DATADOG_RUM_STATIC = {
  site: 'datadoghq.com',
  service: 'Phoenix-UI',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackResources: true,
  trackUserInteractions: true,
  trackLongTasks: true,
} as const;

export function initDatadogRum(environment: Environment): void {
  if (environment.type !== Env.UAT || !environment.datadogRum) {
    return;
  }
  try {
    datadogRum.init({
      ...DATADOG_RUM_STATIC,
      applicationId: environment.datadogRum.applicationId,
      clientToken: environment.datadogRum.clientToken,
      env: environment.type,
      version: environment.version ?? '1.0.0',
    });
  } catch (err) {
    console.warn('[Datadog] RUM init failed', err);
  }
}
